import { CoreMenu } from 'src/@core/types';
import { employeeUtilsMenu } from './employee.utils.menu';

export const setupMenu: CoreMenu[] = [
  {
    id: 'Organization-Setup',
    title: 'Organization Setup',
    type: 'collapsible',
    icon: 'workspace.svg',
    role: {
      roles: ['employee'],
      right: ['L1081', 'L1008', 'L1070', 'L1016', 'L1020'],
    },
    children: [
      {
        id: 'Workspace',
        title: 'Workspace',
        type: 'item',
        icon: 'workspace.svg',
        url: '/setup/workspace',
        role: {
          roles: ['employee'],
          right: 'L1081',
        },
      },
      {
        id: 'Company',
        title: 'Company',
        type: 'item',
        icon: 'company.svg',
        url: '/setup/company',
        role: {
          roles: ['employee'],
          right: 'L1008',
        },
      },
      {
        id: 'Station',
        title: 'Station',
        type: 'item',
        icon: 'station.svg',
        url: '/setup/station',
        role: {
          roles: ['employee'],
          right: 'L1070',
        },
      },
      {
        id: 'Department',
        title: 'Department',
        type: 'item',
        icon: 'department.svg',
        url: '/setup/department',
        role: {
          roles: ['employee'],
          right: 'L1016',
        },
      },
      {
        id: 'Designation',
        title: 'Designation',
        type: 'item',
        icon: 'designation.svg',
        url: '/setup/designation',
        role: {
          roles: ['employee'],
          right: 'L1020',
        },
      },
    ],
  },
  {
    id: 'Location-Setup',
    title: 'Location Setup',
    type: 'collapsible',
    icon: 'cities.svg',
    role: {
      roles: ['employee'],
      right: ['L1012', 'L1004'],
    },
    children: [
      {
        id: 'Countries',
        title: 'Country',
        type: 'item',
        icon: 'countries.svg',
        url: '/setup/countries',
        role: {
          roles: ['employee'],
          right: 'L1012',
        },
      },
      {
        id: 'Cities',
        title: 'City',
        type: 'item',
        icon: 'cities.svg',
        url: '/setup/cities',
        role: {
          roles: ['employee'],
          right: 'L1004',
        },
      },
    ],
  },
  {
    id: 'Employee-Management',
    title: 'Employee Management',
    type: 'collapsible',
    icon: 'profile-management.svg',
    role: {
      roles: ['employee'],
      right: ['L1032', 'L1024', 'L1028', 'L1060', 'L1066', 'L1087', 'L1089'],
    },
    children: [
      ...employeeUtilsMenu, // Includes Employee Types, Categories, and Grades
      {
        id: 'Attendance-Machine',
        title: 'Attendance Machine',
        type: 'item',
        icon: 'attendance-machine.svg',
        url: '/setup/machine',
        role: {
          roles: ['employee'],
          right: 'L1089',
        },
      },
      {
        id: 'Allowance',
        title: 'Allowance',
        type: 'item',
        icon: 'allowances.svg',
        url: '/setup/allowance',
        role: {
          roles: ['employee'],
          right: 'L1087',
        },
      },
      {
        id: 'Roles',
        title: 'Role',
        type: 'item',
        icon: 'roles.svg',
        url: '/setup/roles',
        role: {
          roles: ['employee'],
          right: 'L1060',
        },
      },
      {
        id: 'Shifts',
        title: 'Shift',
        type: 'item',
        icon: 'shifts.svg',
        url: '/setup/shifts',
        role: {
          roles: ['employee'],
          right: 'L1066',
        },
      },
      {
        id: 'Qualifications',
        title: 'Qualification',
        type: 'item',
        icon: 'qualification.svg',
        url: '/setup/qualification',
        role: {
          roles: ['employee'],
          right: 'L1105',
        },
      },
      {
        id: 'Remote-Attendace',
        title: 'Remote Attendance',
        type: 'item',
        icon: 'remote-attendance.svg',
        url: '/setup/remote-attendance',
        role: {
          roles: ['employee'],
          right: 'L1266',
        },
      },
    ],
  },
  {
    id: 'Project-Management',
    title: 'Project Management',
    type: 'collapsible',
    icon: 'project.svg',
    role: {
      roles: ['employee'],
      right: ['L1056', 'L1074'],
    },
    children: [
      {
        id: 'Project-Categories',
        title: 'Project Category',
        type: 'item',
        icon: 'categories.svg',
        url: '/setup/categories',
        role: {
          roles: ['employee'],
          right: 'L1024',
        },
      },
      {
        id: 'Statuses',
        title: 'Status',
        type: 'item',
        icon: 'status.svg',
        url: '/setup/statuses',
        role: {
          roles: ['employee'],
          right: 'L1074',
        },
      },
    ],
  },
  {
    id: 'Other',
    title: 'Other',
    type: 'collapsible',
    icon: 'settings.svg',
    role: {
      roles: ['employee'],
      right: ['L1000', 'L1036', 'L1049', 'L1048', 'L1044', 'L1093', 'L1095'],
    },
    children: [
      {
        id: 'Banks',
        title: 'Bank',
        type: 'item',
        icon: 'banks.svg',
        url: '/setup/banks',
        role: {
          roles: ['employee'],
          right: 'L1000',
        },
      },
      {
        id: 'Holidays',
        title: 'Holiday',
        type: 'item',
        icon: 'holidays.svg',
        url: '/setup/holidays',
        role: {
          roles: ['employee'],
          right: 'L1036',
        },
      },
      {
        id: 'Policy-Types',
        title: 'Policy Type',
        type: 'item',
        icon: 'policy-types.svg',
        url: '/setup/policy-types',
        role: {
          roles: ['employee'],
          right: 'L1049',
        },
      },
      {
        id: 'notification-settings',
        title: 'Notification Setting',
        type: 'item',
        icon: 'notification-settings.svg',
        url: '/setup/notification-settings',
        role: {
          roles: ['employee'],
          right: 'L1048',
        },
      },
      {
        id: 'AllowedIPs',
        title: 'Allowed IP',
        type: 'item',
        icon: 'settings.svg',
        url: '/setup/allowed-ips',
        role: {
          roles: ['employee'],
          right: 'L1188',
        },
      },
      {
        id: 'Letter-Template',
        title: 'Letter Template',
        type: 'item',
        icon: 'letter-template.svg',
        url: '/setup/letter-template',
        role: {
          roles: ['employee'],
          right: 'L1044',
        },
      },
      {
        id: 'Email-Logs',
        title: 'Email Logs',
        type: 'item',
        icon: 'letter-template.svg',
        url: '/setup/email-logs',
        role: {
          roles: ['employee'],
          right: 'L1093',
        },
      },
      {
        id: 'Email-Settings',
        title: 'Email Setting',
        type: 'item',
        icon: 'letter-template.svg',
        url: '/setup/email-setting',
        role: {
          roles: ['employee'],
          right: 'L1095',
        },
      },
    ],
  },
  {
    id: 'Independent Forms Modules',
    title: 'Forms',
    type: 'item',
    icon: 'all-forms.svg',
    url: '/setup/forms',
    role: {
      roles: ['employee'],
      right: 'L1040',
    },
  },
  {
    id: 'Key Responsibility Areas',
    title: 'Key Responsibility Area',
    type: 'item',
    icon: 'kra.svg',
    url: '/setup/kra',
    role: {
      roles: ['employee'],
      right: 'L1099',
    },
  },

   {
    id: 'Employee-Document-Settings',
    title: 'Employee Document Settings',  
    type: 'item',
    icon: 'employee-document-settings.svg',
    url: '/setup/employee-document-settings',
    role: {
      roles: ['employee'],
      right: 'L1500',
    },
  },
  {
    id: 'Workspace Management',
    title: 'Workspace Management',
    type: 'item',
    icon: 'workspace-management.svg',
    url: '/setup/workspace/manage',
    role: {
      roles: ['employee'],
      right: 'L1298',
    },
  },


  {
    id: 'Customer-Forms-Management',
    title: 'Customer Forms',
    type: 'collapsible',
    icon: 'Customer-Form.jpeg',
    role: {
      roles: ['employee'],
      right: ['L1378'],
        },
    children: [
      {
        id: 'Customer-Lists',
        title: 'Customer Lists',
        type: 'item',
        icon: 'Customer-list.jpeg',
        url: '/setup/customer-forms/customer-list',
        role: {
          roles: ['employee'],
          right: 'L1453',
        },
      },
      {
        id: 'Customer-Forms',
        title: 'Customer Forms',
        type: 'item',
        icon: 'Customer-Form.jpeg',
        url: '/setup/customer-forms/customer-forms',
        role: {
          roles: ['employee'],
          right: 'L1452',
        },
      },
    ],
  },


];
